import { Card, Col, Row, Collapse, Button } from 'antd';

import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { errorCatch, GET, If, IfElse, JSXMap } from 'fennec-ui';
import { Action } from 'fennec-ui'
import QRCode from "react-qr-code";
import YImage from '../../../common/YImage';
import EventListItem from '../../components/EventListItem';
import PageLayout from '../../components/PageLayout';
import { eventRoleControler } from '../../../common/Tool';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

const { Panel } = Collapse;

const useStyles = createUseStyles({
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 10px",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	}
})


const SingleEvent = (props) => {
	const classes = useStyles();
	const { auth, event, size, qr } = props;

	const playbillSize = "78px";

	const sameDay = (start, end) => {
		var mstart = dayjs(start);
		var mend = dayjs(end);
		var year1 = mstart.year(), month1 = mstart.month(), day1 = mstart.date();
		var day1n = mstart.add(24, 'hour')
		var year2 = mend.year(), month2 = mend.month(), day2 = mend.date();
		var hour2 = mend.hour();
		if (year1 == year2 && month1 == month2 && ((day2 == day1) || (day2 == day1n && hour2 < 8))) {
			return true
		}
		return false
	};
	const kategorii = (data) => {
		let result = [];
		let mResult = new Map();
		if (data) {
			for (let idx = 0; idx < data.length; idx++) {
				const item = data[idx];
				let kat = mResult.get(item.tantsevalnayaDistsiplinaID);
				if (!kat) {
					kat = {
						tantsevalnayaDistsiplina: item.tantsevalnayaDistsiplina,
						kategoriiUchastnikov: [],
						mKategoriiUchastnikov: new Map(),
					}
					mResult.set(item.tantsevalnayaDistsiplinaID, kat);
					result.push(kat);
				}
				let ok = kat.mKategoriiUchastnikov.get(item.kategoriyaUchastnikovID);
				if (!ok) {
					kat.mKategoriiUchastnikov.set(item.kategoriyaUchastnikovID, data[idx].kategoriyaUchastnikov)
					kat.kategoriiUchastnikov.push(data[idx].kategoriyaUchastnikov);
				}
			}
		}

		for (let idx = 0; idx < result.length; idx++) {
			result[idx].kategoriiUchastnikov.sort((a, b) => a.ID - b.ID);
		}

		result.sort((a, b) => a.tantsevalnayaDistsiplina.ID - b.tantsevalnayaDistsiplina.ID);

		return result
	}
	const kategoriiView = (e) => {
		const list = kategorii(e.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie);
		if (list.length <= 0) return <></>;
		return (
			<div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
				<div className={classes.fieldName}>Категории:</div>
				<ul style={{ listStyle: "none", paddingInlineStart: "2px", fontSize: "13px" }}>
					{list.map((kat, i) => {
						return <li key={i}>
							{kat.tantsevalnayaDistsiplina.nazvanie + " "}
							({
								kat.kategoriiUchastnikov.map((itemD, idx) => {
									if (idx + 1 < kat.kategoriiUchastnikov.length) {
										return <span key={idx}>{itemD.nazvanie.toLowerCase() + ", "}</span>
									} else {
										return <span key={idx}>{itemD.nazvanie.toLowerCase()}</span>
									}
								})
							})
						</li>
					})}
				</ul>
			</div>
		);
	};
	if (!event) return <></>;
	const appendToArray = (target, source) => {
		if (!target) return source;
		return (!source) ? target : [...target, ...source];
	}

	return (
		<div className="event-block" style={{ display: "flex", justifyContent: "space-between" }}>
			<div style={{ maxWidth: "78px" }}>
				<div style={{ width: playbillSize, height: playbillSize, overflow: "hidden", marginBottom: "5px" }}>
					<YImage item={event} width={78} hidePreview={true} />
					{/* <YImage image={e.afisha} minimage={e.afishaMin} width={imgSize} /> */}
				</div>
				<div style={(size !== "small") ? { marginTop: "7px" } : {}}>
					<div style={{
						backgroundColor: "#eaeaea",
						fontSize: "16px",
						fontWeight: "400",
						color: "black",
						borderRadius: "6px",
						textAlign: "center",
						padding: "0 7px",
						textAlign: "center",
					}}>
						<div style={{
							borderRadius: "5px",
							backgroundColor: "#f6214b",
							fontSize: "12px",
							fontWeight: "600",
							color: "white",
							margin: "0 -7px",
							boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
							padding: "3px 7px"
						}}>
							{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
							{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
								dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')
							}
							{true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
								<>
									<div style={{ fontSize: "16px" }}>
										{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD')}
										-
										{dayjs(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('DD')}
									</div>
									<div style={{ fontSize: "14px" }}>
										{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('MMMM')} {dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('YYYY')}
									</div>
								</>
							} */}
						</div>
						<div style={{
							fontSize: "10px",
							fontWeight: "400",
							padding: "0px"
						}}>
							{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
								{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							</>}
							{true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
								{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
								<span> - </span>
								{dayjs(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							</>} */}
						</div>
					</div>
				</div>
			</div>
			<div style={{ flex: "auto", paddingLeft: "7px" }}>
				<div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					{/* <span className={classes.fieldName}>Название: </span> */}
					<span className={classes.fieldValue} style={{ fontWeight: "600", fontSize: (size !== "small") ? "14px" : "18px" }}>
					<a href={`/fed/event/${event.ID}`}>
						{event.nazvanieMeropriyatiya}
						</a>
						</span>
				</div>
				<div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Уровень: </span><span className={classes.fieldValue}>{event.urovenMeropriyatiya.opisanie}</span>
				</div>
				<div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Место проведения: </span>
					<span className={classes.fieldValue}>{event.mestoProvedeniya.name}</span>
				</div>
				{((event?.eventUserMeropriyatie?.length > 0) && !!auth) && <div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", display: "flex", flexDirection: "column", gap: "5px" }}>
					<div>
						<a className='btn btn-primary btn-sm' href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${event.ID}`}>Войти в мероприятие</a>
					</div>
					{/* {JSXMap(event?.eventUserMeropriyatie,(role, idx)=>(<div>
						<a className='btn btn-primary btn-sm' href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${event.ID}`}>{role?.eventUserType?.description}</a>
					</div>))} */}
				</div>}
				{(size !== "small") && kategoriiView(event)}
			</div>
			{qr && <div>
				<Action
					auth={auth}
					action={() => {
						// console.log(values, unlock, close); 
					}}
					object={qr}
					modal={{
						width: "580px",
						title: "QR"
					}}

					readonly={true}
					mode={"func"}
					noAntForm={true}
					form={(props) => {
						const { object } = props;
						return <div style={{ display: "flex", justifyContent: "center" }}>
							{object &&
								<div>
									{event && <div style={{ paddingBottom: "25px" }}>
										<SingleEvent auth={auth} event={event} size="small" />
									</div>}
									<div style={{ padding: "20px", backgroundColor: "white", borderRadius: "6px" }}>
										<QRCode size={512} level="M" value={object} />
									</div>
								</div>}
						</div>
					}}
					trigger={(click) => (
						<Button type="text" onClick={event => {
							event.stopPropagation();
							click();
						}}>
							<div style={{ padding: "3px", backgroundColor: "white", borderRadius: "6px" }}>
								<QRCode size={78} value={qr} />
							</div>
						</Button>
					)}
				/>
			</div>}
		</div>
	);
}

export default function CommonEventsMyevents(props) {
	const classes = useStyles();
	const { auth } = props;
	const [tickets, setTickets] = React.useState();
	useEffect(() => {
		GET(auth, "/api/my-meropriyatiya", ({ data }) => {
			if (data) {
				setTickets(o => {
					let r = data.map(e => ({
						Data: "",
						Meropriyatie: e,
						TicketList: []
					}))
					return r.sort((a, b) => {
						if (a?.Meropriyatie?.nachaloSorevnovaniya > b?.Meropriyatie?.nachaloSorevnovaniya) return 1;
						if (a?.Meropriyatie?.nachaloSorevnovaniya == b?.Meropriyatie?.nachaloSorevnovaniya) return 0;
						if (a?.Meropriyatie?.nachaloSorevnovaniya < b?.Meropriyatie?.nachaloSorevnovaniya) return -1;
					});
				});

				GET(auth, "/api/ticket/actual", ({ data }) => {
					if (data) {
						setTickets(o => {

							let r = _.unionWith(o, data, (a, b)=>a.Meropriyatie.ID === b.Meropriyatie.ID);

							for (let i = 0; i < r.length; i++) {
								const ev = r[i];
								let t = data.find(fo => fo.Meropriyatie.ID === ev.Meropriyatie.ID);
								if(t){
									r[i] = {
										...r[i],
										Data: t.Data,
										TicketList: t.TicketList
									}
								}
							}

							return r.sort((a, b) => {
								if (a?.Meropriyatie?.nachaloSorevnovaniya > b?.Meropriyatie?.nachaloSorevnovaniya) return 1;
								if (a?.Meropriyatie?.nachaloSorevnovaniya == b?.Meropriyatie?.nachaloSorevnovaniya) return 0;
								if (a?.Meropriyatie?.nachaloSorevnovaniya < b?.Meropriyatie?.nachaloSorevnovaniya) return -1;
							});
						});
					}
				}, errorCatch)
			}
		}, errorCatch)
	}, []);

	return (
		<PageLayout hideBreadcrumbs={true}>
			<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
				<div style={{ padding: "10px" }}>
					{tickets && <Row gutter={[5, 5]}>
						<Col span={24}>
							<div style={{
								fontSize: "18px",
								fontWeight: "500",
								paddingBottom: "10px"
							}}>
								Мои мероприятия
							</div>
							<div>
								{JSXMap(tickets, (e, idx) => {
									const appendYacheikaUsluga = (arr, tick) => {
										let a = (arr) ? [...arr] : [];
										a.push({
											...tick.uslugaKlientu.yacheikaUsluga,
											kategoriya: (tick.kategoriya && tick.kategoriya.kategoriya) ? tick.kategoriya.kategoriya : undefined,
										});

										return a.sort(function (a, b) {
											if (a.kategoriya && !b.kategoriya) {
												return -1;
											}
											if (!a.kategoriya && b.kategoriya) {
												return 1;
											}
											return 0;
										});;
									};
									const ticket = () => {
										let m = {};
										for (let i = 0; i < e.TicketList.length; i++) {
											const tick = e.TicketList[i];
											let o = m[tick.uslugaKlientu.uslugaNaMeropriyatii.ID] || tick.uslugaKlientu.uslugaNaMeropriyatii;
											o = {
												...o,
												summa: ((o.summa) ? o.summa : 0) + tick.summa,
												yacheikaUsluga: appendYacheikaUsluga(o.yacheikaUsluga, tick),
											};
											m[tick.uslugaKlientu.uslugaNaMeropriyatii.ID] = o;
										}
										return Object.values(m);
									};

									return (<EventListItem
										key={idx}
										event={e?.Meropriyatie}
										qr={e?.Data}
										tickets={ticket()}
										eventUsers={e?.Meropriyatie?.eventUserMeropriyatie}
										size={(idx === 0) ? "large" : (dayjs(e?.Meropriyatie?.nachaloSorevnovaniya).isBefore(dayjs().add(14, 'day'))) ? "medium" : "small"}
										extButtons={({path, size, style}) => [
											If(eventRoleControler(e?.Meropriyatie),<div key="controller">
												<a
													style={style}
													className={`btn btn-soft-secondary btn-sm`}
													href={`/app/checkticket/${e?.Meropriyatie?.ID}`}
												>
													Проверка билетов
												</a>
											</div>)
										]}
									/>)
								})}
							</div>
						</Col>
					</Row>}
				</div>
			</div>
		</PageLayout>
	);
}
